import { post } from "../../service/api";

const CheckRegisterDuplicate = async (register) => {
  try {
    const response = await post(`/merchant/checkDuplicate/register`, {
      register,
    });
    return response;
  } catch (error) {
    console.error("Error CheckRegisterDuplicate:", error);
    throw error;
  }
};

export default CheckRegisterDuplicate;
